import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import 'firebase/compat/auth';
import { getCompany } from 'helpers/getCompanyVariables';
import {
  getPushNotificationsAndPopUps,
  getPopUp,
  getLimitedUserPopUp
} from 'state/actions/notifications';
import PopUpModal from 'components/PopUpCustomModal/PopUpCustomModal';
import { SET_POP_UP } from 'constants/types';
import {
  PortalWalkthroughProvider,
  usePortalWalkthrough
} from 'tailwind-components/PortalWalkthrough/PortalWalkthroughContext';

function PopUpWhenTourInactive({ popUp, closePopUp }) {
  const { isActive } = usePortalWalkthrough() || {};
  if (isActive) return null;
  return <PopUpModal popUp={popUp} closePopUp={closePopUp} />;
}

PopUpWhenTourInactive.propTypes = {
  popUp: PropTypes.object.isRequired,
  closePopUp: PropTypes.func.isRequired
};
import { isAgentRankLimited } from 'helpers/agents';
import PropTypes from 'prop-types';

const company = getCompany();

export default function PrivateRoute() {
  // redux
  const dispatch = useDispatch();
  const location = useLocation();
  const { zohoId, zohoData: user } = useSelector(state => state.user);
  const { authenticated, mustChangePassword } = useSelector(
    state => state.authentication
  );
  const { pop_up: popUp } = useSelector(state => state.notifications);

  const isAuthenticated = authenticated && zohoId;

  const isAgentLimited = isAgentRankLimited(user.Rank);

  // fetch push notifications and pop up
  useEffect(() => {
    if (company === 'oneill' && isAuthenticated && !mustChangePassword) {
      if (isAgentLimited) {
        dispatch(getLimitedUserPopUp());
      } else {
        dispatch(getPushNotificationsAndPopUps());
        dispatch(getPopUp());
      }
    }
  }, [isAuthenticated, mustChangePassword]);

  // build redirect URL with current path and search params
  const getLoginUrl = () => {
    const redirectPath = location.pathname + location.search;
    // only add redirect param if we're not already on login or home page
    if (redirectPath !== '/login' && redirectPath !== '/') {
      return `/login?redirect=${encodeURIComponent(redirectPath)}`;
    }
    return '/login';
  };

  // users created with a temporary password must change it before using the portal
  if (isAuthenticated && mustChangePassword) {
    return <Navigate to='/force-change-password' replace />;
  }

  return isAuthenticated ? (
    <>
      <PortalWalkthroughProvider>
        <Outlet />
        {popUp && (
          <PopUpWhenTourInactive
            popUp={popUp}
            closePopUp={() =>
              dispatch({
                type: SET_POP_UP,
                payload: null
              })
            }
          />
        )}
      </PortalWalkthroughProvider>
    </>
  ) : (
    <Navigate to={getLoginUrl()} replace />
  );
}
